var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex", staticStyle: { gap: "10px" } },
    [
      _c(
        "div",
        {
          staticClass: "form-group bmd-form-group is-filled",
          staticStyle: { width: "70%" }
        },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.text[_vm.languages[_vm.selectedIndex].key],
                expression: "text[languages[selectedIndex].key]"
              }
            ],
            staticClass: "form-control",
            attrs: { name: "title_textarea_2302a23", rows: "2" },
            domProps: { value: _vm.text[_vm.languages[_vm.selectedIndex].key] },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.text,
                  _vm.languages[_vm.selectedIndex].key,
                  $event.target.value
                )
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success dropdown-toggle",
            attrs: {
              type: "button",
              id: "dropdownMenuButton",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false"
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.languages[_vm.selectedIndex].value) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": "dropdownMenuButton" }
          },
          _vm._l(_vm.languages, function(language, lKey) {
            return _c(
              "div",
              {
                key: lKey,
                staticClass: "dropdown-item",
                on: {
                  click: function($event) {
                    return _vm.selectLanguage(lKey)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    staticStyle: { gap: "10px", "align-items": "center" }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(language.value) +
                        "\n                    "
                    ),
                    _vm.text[language.key]
                      ? _c("span", { staticClass: "label-success" }, [
                          _vm._v("OK")
                        ])
                      : _vm._e()
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text-danger" }, [
        _vm.text["tr_TR"] === undefined || _vm.text["tr_TR"] === ""
          ? _c("span", [_vm._v("\n            Zorunlu: [TR]\n        ")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.createHiddenInput
        ? _vm._l(Object.entries(_vm.text), function(item, iKey) {
            return _c("div", { key: iKey }, [
              _c("input", {
                attrs: { name: _vm.name + "[" + item[0] + "]", type: "hidden" },
                domProps: { value: item[1] }
              })
            ])
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cbfbfbf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbfbfbf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/@components/i18n-textarea.vue
// module id = 105
// module chunks = 0